<template>
  <q-page style="height: 100vh">
    <q-img
      src="/statics/loginBanner.jpg"
      style="height: 100vh; position: absolute; width: 100vw"
    >
    </q-img>
    <q-btn
      style="position: fixed; top: 10px; right: 10px"
      flat
      color="negative"
      icon="lock"
      @click="$store.dispatch('auth/logout')"
    >
    </q-btn>
    <div class="row" align="center" justify="center">
      <div class="col">
        <q-card style="" class="wizardCard fixed-center" id="wizardCard">
          <q-btn
            v-if="chosenOutcome && questionsHeaderRender"
            @click="$store.dispatch('outcomes/select', null)"
            class="homeButtom"
            flat
            icon="mdi-view-grid"
          >
          </q-btn>
          <transition
            appear
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
          >
            <q-card-section
              v-if="!chosenOutcome && !questionsHeaderRender"
              class="q-pb-none"
            >
              <div class="row">
                <div class="col-12">
                  <div style="max-width: 280px; max-height: 90%">
                    <q-img
                      src="/statics/Logo.png"
                      spinner-color="white"
                      :ratio="2 / 1"
                      contain
                    />
                  </div>
                </div>
              </div>
            </q-card-section>
          </transition>
          <transition
            appear
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
          >
            <q-card-section v-if="chosenOutcome && questionsHeaderRender">
              <div class="col-12">
                <div style="height: 100px !important; width: 100px !important">
                  <q-img
                    :src="chosenOutcome.imgUrl"
                    spinner-color="white"
                    :ratio="1 / 1"
                    contain
                  />
                </div>
                <h3 class="text-center q-ma-sm">
                  {{ chosenOutcome.label }}
                </h3>
              </div>
            </q-card-section>
          </transition>
          <q-card-section class="q-pt-none">
            <q-slide-transition>
              <div
                v-if="
                  outcomes &&
                  !outcomesLoading &&
                  !chosenOutcome &&
                  !renderAnswerQuestions
                "
              >
                <q-scroll-area
                  style="max-height: calc(80vh - 125px); height: 100vh"
                  :thumb-style="{
                    background: '#162c479c',
                    opacity: 1,
                    width: '8px',
                    height: '8px',
                    borderRadius: '20px',
                  }"
                >
                  <div class="row">
                    <div></div>
                    <div
                      v-for="(outcome, index) in outcomes"
                      :key="`outcome_${index}`"
                      class="cols"
                      style="margin: auto"
                    >
                      <q-card
                        @click="$store.dispatch('outcomes/select', outcome)"
                        flat
                        class="outcomeCard q-pa-md cursor-pointer"
                      >
                        <q-card-section>
                          <svg class="progress-ring" width="220" height="220">
                            <circle
                              :ref="`progressRing_${outcome.id}`"
                              class="progress-ring__circle"
                              stroke="#6cbd4f"
                              stroke-width="8"
                              fill="transparent"
                              r="105"
                              cx="110"
                              cy="110"
                            />
                          </svg>
                          <q-img
                            :src="outcome.imgUrl"
                            spinner-color="white"
                            :ratio="1 / 1"
                            contain
                            class="outcomeImg"
                          />

                          <h3
                            style="font-size: 15pt !important"
                            class="text-center q-ma-sm"
                          >
                            {{ outcome.label }}
                          </h3>
                        </q-card-section>
                      </q-card>
                    </div>
                  </div>
                </q-scroll-area>
              </div>
            </q-slide-transition>
            <q-slide-transition>
              <div v-if="chosenOutcome && renderAnswerQuestions">
                <q-scroll-area
                  style="max-height: calc(80vh - 125px); height: 100vh"
                  :thumb-style="{
                    background: '#162c479c',
                    opacity: 1,
                    width: '8px',
                    height: '8px',
                    borderRadius: '20px',
                  }"
                >
                  <div class="row">
                    <div
                      class="col-12 col-md-6"
                      v-for="(category, index) in chosenOutcome.questions"
                      :key="`category_${index}`"
                    >
                      <q-card class="q-ma-sm bg-grey-2">
                        <q-card-section>
                          <h6 class="q-ma-none text-left">
                            {{ category.title }}
                          </h6>
                        </q-card-section>
                        <q-card-section>
                          <div class="row">
                            <div
                              class="col-12 q-px-sm"
                              v-for="(question, index) in category.questions"
                              :key="`question_${index}`"
                            >
                              <q-input
                                :label="question.message"
                                v-model="formData[question.id]"
                                :suffix="question.unit"
                                @blur="saveAllAnswers()"
                              >
                                <template v-if="question.tooltip" #append>
                                  <q-icon name="help">
                                    <q-tooltip>
                                      {{ question.tooltip }}
                                    </q-tooltip>
                                  </q-icon>
                                </template>
                              </q-input>
                            </div>
                          </div>
                        </q-card-section>
                      </q-card>
                    </div>
                  </div>
                </q-scroll-area>
              </div>
            </q-slide-transition>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        outcomes: "outcomes/list",
        outcomesLoading: "outcomes/listLoading",
        chosenOutcome: "outcomes/chosenOutcome",
      }),
    },
    data: () => ({
      outcomeHover: null,
      formData: {},
      renderAnswerQuestions: false,
      questionsHeaderRender: false,
    }),
    watch: {
      chosenOutcome: function () {
        setTimeout(() => {
          this.renderAnswerQuestions = !this.renderAnswerQuestions;
          this.questionsHeaderRender = !this.questionsHeaderRender;
          if (this.chosenOutcome) {
            if (Array.isArray(this.chosenOutcome.answers)) {
              this.formData = {};
            } else {
              this.formData = JSON.parse(
                JSON.stringify(this.chosenOutcome.answers)
              );
            }
          } else {
            this.calculateOutcomeProgress();
          }
        }, 700);
      },
    },
    beforeCreate() {
      this.$store.dispatch("outcomes/loadAllForWizard");
      this.$store.dispatch("outcomes/select", null);
    },
    mounted() {
      setTimeout(() => {
        this.calculateOutcomeProgress();
      }, 500);
    },
    methods: {
      saveAllAnswers() {
        this.$store.dispatch("questions/saveAllAnswers", this.formData);
      },
      calculateOutcomeProgress() {
        setTimeout(() => {
          this.outcomes.forEach((outcome) => {
            let circle = this.$refs[`progressRing_${outcome.id}`][0];
            let radius = circle.r.baseVal.value;
            let circumference = radius * 2 * Math.PI;
            circle.style.strokeDasharray = `${circumference} ${circumference}`;

            let answersLength = Array.isArray(outcome.answers)
              ? 0
              : Object.keys(outcome.answers).length;

            let percent = (answersLength / outcome.questionsCount) * 100;
            const offset = circumference - (percent / 100) * circumference;
            circle.style.strokeDashoffset = offset;
          });
        }, 50);
      },
    },
  };
</script>

<style lang="scss">
  .wizardCard {
    max-width: 80vw;
    width: 80vw;
    max-height: 90vh;
  }

  .outcomeCard {
    width: 240px;

    .outcomeImg {
      transition: all 0.2s ease-in-out;
    }

    .outcomeImg:hover {
      transform: scale(1.1);
    }
  }

  h3,
  h6 {
    color: $secondary;
    font-weight: 400;
  }

  #wizardCard {
    .homeButtom {
      position: absolute;
      top: 15px;
      right: 15px;
      z-index: 2;
    }
  }

  .progress-ring {
    stroke-dasharray: 628.319, 628.319;
    position: absolute;
    left: -6px;
    top: -6px;
  }

  .progress-ring__circle {
    transition: 0.35s stroke-dashoffset;
    // axis compensation
    transform: rotate(90deg);
    transform-origin: 50% 50%;
  }
</style>
